import request from './request';

export const httpDelete = <T>(url: string): Promise<T> => request(url, { method: 'DELETE' });
